import { isNull, or, sql } from "drizzle-orm";
import type { SQLiteColumn } from "drizzle-orm/sqlite-core";

export function inArrayOrNullIfNullable(column: SQLiteColumn, list: string[]) {
	const inListSQL = sql`${column} IN (${sql.raw(`${list.map(value => `'${value}'`).join(", ")}`)})` // would use inArray, but it uses parameters (which can't be in CHECK clauses)
	if (column.notNull) return inListSQL;
	return or(isNull(column), inListSQL)!;
}
